import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { NotifiactionsDTO, DesktopNotify, OnBoardingNotifications, NotificationCountDetail } from '../_shared/_models/jobsAndTalents/jobsAndTalentsModels';
import { CommonService } from '@services/app.common.service';
import { Router } from '@angular/router';
import { RoleAccessService } from '../_shared/_services/role.access.service';
import { ClientDivisionItem, SecurityRoleItems } from '../_shared/_enums/securityRoleItems';
import { NotificationType } from './_notification-enums';
import { ClientConfiguation } from '../_shared/_enums/clientConfiguration';



@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
/*  styleUrls: ['./notifications.component.css'],*/
})
export class NotificationsComponent implements OnInit {

  public notification = {} as NotifiactionsDTO;
  public obNotification: OnBoardingNotifications[] = [];
  public permission = {} as DesktopNotify;
  public type: string = 'candidate';
  public isNotificationLoaded: boolean = false;
  public isOBNotifitionsAllowed: boolean = false;
  public pageNo: number = 0;
  public candidateCount: number = 0;
  public smsCount: number = 0;
  public emailCount: number = 0;
  public authCount: number = 0;
  public obTotalNotifications: number = 0;
  public totalNotifications: number = 0;
  public notificationCountDetail = {} as NotificationCountDetail;
  public NotificationType = NotificationType;

  public weeklyActive: boolean = true;
  public monthlyActive: boolean = false;
  public quarterlyActive: boolean = false;
  public daysRange: string = 'weekly';
  public IsEnableNotificationDropdown: boolean = false;
  @Output() byLoad: EventEmitter<any> = new EventEmitter();
  constructor(public common: CommonService, private router: Router, public roleService: RoleAccessService) {

  }

  ngOnInit() {
    this.NotificationCount();
    this.Notification();
    //this.GetOnBoardingNotifications();
    if (this.common.getBoolean(this.common.readClientConfiguration(ClientConfiguation.ShowObV2))) {
      this.isOBNotifitionsAllowed = this.roleService.HasAccess(SecurityRoleItems.Compliance_OnBoardingNotifications);
    }
  }

  public NotificationCount() {
    const notifications = JSON.parse(this.common.GetFromLocalStorage('NotificationCount'));
    this.candidateCount = notifications.candidateCount;
    this.smsCount = notifications.smsCount;
    this.emailCount = notifications.emailCount;
    this.authCount = notifications.authCount;
    this.obTotalNotifications = notifications.obTotal;
  }

  public tabSelection(type: string) {
    if (type != undefined && type != null && type != '') {
      this.type = type;
    }
    this.pageNo = 0;
    this.Notification();
  }

  public Notification(appendRecord = false) {

    this.pageNo = this.pageNo + 1;
    const param = {
      pageSize: 20,
      pageNo: this.pageNo,
      type: this.type,
      daysRange: this.daysRange
    };
    this.totalNotifications = 0;
    if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.OnBoardingNotification) && this.isOBNotifitionsAllowed == true) {
      this.common.listingParams.skip = (this.pageNo - 1) * this.common.listingParams.pageSize;
      this.common.listingParams.daysRange = this.daysRange;
      this.common.PostData(this.common.ApiUrls.OnBoardingNotifications.GetOnBoardingNotifications, this.common.listingParams, true).then(data => {
        if (!appendRecord) {
          this.obNotification = data.resultData;
          this.obTotalNotifications = 0;
          if (this.obNotification != null && this.obNotification.length > 0) {
            this.obTotalNotifications = this.obNotification[0].totalRows;
            this.isNotificationLoaded = true;
            this.UpdateAndSetTotalNotification(this.type, this.obTotalNotifications)
          }
          else
            this.UpdateAndSetTotalNotification(this.type, this.obTotalNotifications)
        }
        else {
          var data = data.resultData;
          var outerthis = this;
          if (data != null && data != undefined && data.length > 0) {
            data.forEach(function (obj: OnBoardingNotifications) {
              if (outerthis.obNotification.find(d => d.id == obj.id) == undefined) {
                outerthis.obNotification.push(obj);
              }
            });
          }
        }

      }, error => { console.log('erre', error); });

    } else {
      this.common.PostData(this.common.ApiUrls.DashBoard.Notification, JSON.stringify(param), true).then(data => {
        this.obTotalNotifications = 0;
        var totalNotifications = 0;
        if (!appendRecord) {
          this.notification = data.resultData;
          if (this.isOBNotifitionsAllowed) {
            this.obTotalNotifications = this.notification.obTotal;
            this.UpdateAndSetTotalNotification(this.NotificationType.OnBoardingNotification, this.obTotalNotifications)
          }
        }
        else {
          var notificationData = {} as NotifiactionsDTO;
          notificationData = data.resultData;

          if (this.isOBNotifitionsAllowed) {
            this.obTotalNotifications = notificationData.obTotal
            this.UpdateAndSetTotalNotification(this.NotificationType.OnBoardingNotification, notificationData.obTotal)
          }
          if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.Candidate)) {
            for (var i in notificationData.candidates) {
              var option = notificationData.candidates[i];
              if (this.notification.candidates.find(d => d.candidateId == option.candidateId) == null)
                this.notification.candidates.push(option);
            }
          }
          else if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.Texts)) {
            for (var i in notificationData.texts) {
              var text = notificationData.texts[i];
              this.notification.texts.push(text);
            }
          }
          else if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.Email)) {
            for (var i in notificationData.emails) {
              var email = notificationData.emails[i];
              this.notification.emails.push(email);
            }
          }
          else if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.Authorisations)) {
            for (var i in notificationData.authorisations) {
              var authorisations = notificationData.authorisations[i];
              if (this.notification.authorisations.find(d => d.jobReference == authorisations.jobReference) == null)
                this.notification.authorisations.push(authorisations);
            }
          }

          for (var i in notificationData.authorizeCandidates) {
            var authorizeCandidates = notificationData.authorizeCandidates[i];
            this.notification.authorizeCandidates.push(authorizeCandidates);
          }
        }


        this.permission = data.resultData.permission;
        if (this.notification) {
          this.isNotificationLoaded = true;
          if (this.permission != null) {
            if (this.common.LowerCase(this.permission.isCandidates) == 'yes') {
              this.totalNotifications += this.notification.nmStatuses;
              if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.Candidate)) {
                this.candidateCount = this.notification.nmStatuses;
                this.UpdateAndSetTotalNotification(this.type, this.candidateCount)
              }

            }
            if (this.common.LowerCase(this.permission.isJobs) == 'yes') {
              this.totalNotifications += this.notification.nmOfSMS;
              if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.Texts)) {
                this.smsCount = this.notification.nmOfSMS;
                this.UpdateAndSetTotalNotification(this.type, this.smsCount)
              }
            }
            if (this.common.LowerCase(this.permission.isJobs) == 'yes') {
              this.totalNotifications += this.notification.nmOfEmail;
              if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.Email)) {
                this.emailCount = this.notification.nmOfEmail;
                this.UpdateAndSetTotalNotification(this.type, this.emailCount)

              }
            }
            if (this.common.LowerCase(this.permission.isAuthoriseJob) == 'yes' || this.common.LowerCase(this.permission.isAuthoriseCandidate) == 'yes') {
              this.totalNotifications += this.notification.nmOfAutho;
              if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.Authorisations)) {
                this.authCount = this.notification.nmOfAutho;
                this.UpdateAndSetTotalNotification(this.type, this.authCount)
              }
            }


          }

          if (this.isOBNotifitionsAllowed) {
            this.totalNotifications += this.notification.obTotal;
            if (this.common.LowerCase(this.type) == this.common.LowerCase(this.NotificationType.OnBoardingNotification)) {
              this.obTotalNotifications = this.notification.obTotal;
              this.UpdateAndSetTotalNotification(this.type, this.obTotalNotifications)
            }
          }
        }
      });
    }
  }



  public UpdateAndSetTotalNotification(NotificationType: string, Notification: number): void {
    this.notificationCountDetail = this.common.JsonParseData(this.common.GetFromLocalStorage("NotificationCount"));
    if (this.notificationCountDetail != null && this.notificationCountDetail != undefined) {
      let totalNotification = 0;
      switch (this.common.LowerCase(NotificationType)) {
        case this.common.LowerCase(this.NotificationType.Candidate):
          this.notificationCountDetail.candidateCount = Notification;
          break;
        case this.common.LowerCase(this.NotificationType.Texts):
          this.notificationCountDetail.smsCount = Notification;
          break;
        case this.common.LowerCase(this.NotificationType.Email):
          this.notificationCountDetail.emailCount = Notification;
          break;
        case this.common.LowerCase(this.NotificationType.Authorisations):
          this.notificationCountDetail.authCount = Notification;
          break;
        case this.common.LowerCase(this.NotificationType.OnBoardingNotification):
          this.notificationCountDetail.obTotal = Notification;
          break;
      }
      this.common.SetLocalStorage("NotificationCount", JSON.stringify(this.notificationCountDetail));
      totalNotification += this.notificationCountDetail.candidateCount;
      totalNotification += this.notificationCountDetail.emailCount;
      totalNotification += this.notificationCountDetail.smsCount;
      totalNotification += this.notificationCountDetail.authCount;
      totalNotification += this.notificationCountDetail.obTotal;
      this.byLoad.emit(totalNotification);
    }

  }




  //public GetOnBoardingNotifications() {

  //  //  this.isNotificationLoaded = false;
  //  this.common.PostData(this.common.ApiUrls.OnBoardingNotifications.GetOnBoardingNotifications, params, true).then(data => {

  //    this.obNotification = data.resultData;
  //    if (this.obNotification != null) {
  //      this.obTotalNotifications += this.obNotification[0].totalRows;
  //      //  this.totalNotifications += this.obTotalNotifications;
  //      // this.common.SetLocalStorage("TotalNotifications", this.totalNotifications);
  //      // this.byLoad.emit(this.totalNotifications);
  //      this.isNotificationLoaded = true;
  //    }
  //  }, error => { console.log("erre", error); });
  // }

  onScrollDown() {

    this.Notification(true);
  }

  public Detail(d: string) {

    this.type = d;
    const x = this.notification.texts;
  }
  public authDetail(userId: number, jobId: number) {
    const readOnly = 'disabled';
    this.common.NavigateToRouteWithQueryString(this.common.RouteUrls.AddJob.JobDetail, { queryParams: { jobId: jobId, readOnly: readOnly } });
  }
  public candidateDetail(candidateId: number, jobId: number) {


    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this.common.RouteUrls.Jobs.LinkUrl], { queryParams: { Id: jobId, candidateDetail: candidateId, candidateId: candidateId, } });


  }

  public NotificationDetail(notificationId: number, candidateId: number, jobId: number, isRead: boolean) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([this.common.RouteUrls.Jobs.LinkUrl], { queryParams: { Id: jobId, candidateDetail: candidateId, candidateId: candidateId, isRead: isRead, obNotificationId: notificationId } });
  }
  textDetail(smsInboxId: number) {

    this.common.NavigateToRouteWithQueryString(this.common.RouteUrls.SmsInbox.Detail, { queryParams: { id: smsInboxId } });
  }
  emailDetail(emailInboxId: number) {
    this.common.NavigateToRouteWithQueryString(this.common.RouteUrls.EmailInbox.Details, { queryParams: { id: emailInboxId, isRead: 'Yes' } });

}
  public GetNotificationsByDays(type: string) {
    type == 'weekly' ? (this.weeklyActive = true, this.monthlyActive = false, this.quarterlyActive = false) : type == 'monthly' ? (this.weeklyActive = false, this.monthlyActive = true, this.quarterlyActive = false) : type == 'quarterly' ? (this.weeklyActive = false, this.monthlyActive = false, this.quarterlyActive = true) : (this.weeklyActive = false, this.monthlyActive = false, this.quarterlyActive = false);
    this.pageNo = 0;
    this.daysRange = type;
    this.Notification(false);
    this.IsEnableNotificationDropdown = false;
  }

  public ShowNotificationDaysDropDown() {
    this.IsEnableNotificationDropdown = this.IsEnableNotificationDropdown == false ? true : false;
  }

}

